import React, { useEffect, useState } from 'react';
import api from '../../../lib/axios';
import { Box } from '@chakra-ui/react';
import { SearchIcon } from '@chakra-ui/icons';
import BlogCarousel from './BlogCarrousel';


function BlogHomeContent() {

    const [blogs, setBlogs] = useState([]);

    useEffect(() => {
        const fetchBlogs = async () => {
            try {
                const response = await api.get('https://teaapitest.azurewebsites.net/Blogs');
                if (response.data.success) {
                    setBlogs(response.data.data);
                } else {
                    console.log('No se pudieron obtener los blogs:', response.data.message);
                }
            } catch (error) {
                console.error('Error al obtener los blogs:', error);
            }
        };

        fetchBlogs();
    }, []);

    return (
        <div>
            <form className="flex items-center">   
                <div className="relative w-full">
                    <div className="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none">
                        <SearchIcon color="gray.300" />
                    </div>
                    <input type="search" style={{ backgroundColor: '#F5F7FA', borderRadius: '40px' }} 
                        className="text-gray-900 text-sm block w-full ps-10 p-2.5 
                        
                        focus:outline-none focus:ring-2 focus:ring-[#C7DDDA]" 
                        placeholder="Search Blogs or Category" required 
                    />
                </div>
            </form>
            <Box mt="25px">
                <BlogCarousel blogs={blogs} />
            </Box>

        </div>
    );
}

export default BlogHomeContent;
